import React from "react";

export const Detail = ({
  detail,
  handleOpenUserDetail,
}: {
  detail: any;
  handleOpenUserDetail: ({ initIndex }: { initIndex: number }) => void;
}) => {
  return (
    <div className="absolute bg-[rgba(255,255,255,.6)] top-[25px] right-[15px] rounded-[15px] overflow-hidden shadow-lg w-[20rem]">
      <div className="p-2">
        <div className="my-1">
          <p className="text-[1.5rem] font-bold m-1">{detail?.name}</p>
          <div className="flex m-1">
            <p className="text-sm font-bold">Estado:</p>
            <p className="text-sm ml-1">{detail?.state}</p>
          </div>
          <div className="flex m-1">
            <p className="text-sm font-bold">Ciudad:</p>
            <p className="text-sm ml-1">{detail?.city}</p>
          </div>
        </div>
        <div className="my-1 overflow-y-auto h-[350px] no-scrollbar">
          <p className="text-[1.5rem] font-bold m-1">{detail?.users && (<strong className="text-[1.5rem]">{detail?.users.length}</strong>)} usuarios</p>
          {detail
            ? detail.users.map((user: any, index: number) => (
                <div className="flex m-1 justify-between" key={index}>
                  <div className="flex m-1">
                    <div
                      className={`${
                        user.type.indexOf("SUPERVISOR") > -1
                          ? `bg-red-600`
                          : `bg-yellow-400`
                      } w-[20px]  h-[20px] rounded-full flex items-center justify-center`}
                    >
                      <p className="text-sm font-bold text-white">
                        {user.type.indexOf("SUPERVISOR") > -1 ? "S" : "D"}
                      </p>
                    </div>
                    <p className="text-sm ml-1">{user.name}</p>
                  </div>
                  <div
                    className="bg-blue-600 w-[20px] h-[20px] rounded-full flex items-center justify-center cursor-pointer"
                    onClick={() => {
                      handleOpenUserDetail &&
                        handleOpenUserDetail({
                          initIndex: index,
                        });
                    }}
                  >
                    <p className="text-sm font-bold text-white rouded-full">
                      !
                    </p>
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
